import React from 'react';
import { MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { profileProfessions } from '../artistProfile';
import { useAuthorProfiles } from '../services/postInteractions';
import { displayName, formatTime } from '../utils';
import { Avatar, EmptyState } from './UI';

export default function ClubMessageList({ messages, userId, profile, endRef }) {
  const authors = useAuthorProfiles(messages.map((message) => message.userId || message.senderId)
    .filter((id) => id !== userId || !profile));

  return <div className={`message-list club-message-list ${!messages.length ? 'is-empty' : ''}`}>
    {messages.length ? messages.map((message) => {
      const authorId = message.userId || message.senderId;
      const mine = authorId === userId;
      const author = mine && profile ? profile : authors[authorId];
      const identity = {
        username: author?.username || author?.displayName || message.senderName || 'Member',
        photoURL: author?.photoURL ?? message.authorPhotoURL ?? '',
      };
      const area = author
        ? author.area || author.city || author.locationLabel
        : message.authorArea || message.authorCity || message.authorLocationLabel;
      const professions = profileProfessions(author || message).slice(0, 2);
      const Card = authorId ? Link : 'div';

      return <article className={`club-message ${mine ? 'mine' : ''}`} key={message.id}>
        <Card {...(authorId ? { to: `/profile/${authorId}`, title: `View ${displayName(identity)}'s profile` } : {})} className="club-message-card">
          <header className="club-message-author">
            <Avatar profile={identity} size={36} />
            <div className="club-message-identity">
              <strong>@{displayName(identity)}</strong>
              {(area || professions.length > 0) && <div className="club-message-details">
                {area && <span className="club-message-area"><MapPin size={11} aria-hidden="true" />{area}</span>}
                {!!professions.length && <span>{professions.join(', ')}</span>}
              </div>}
            </div>
          </header>
          {message.imageUrl && <img className="club-message-attachment" src={message.imageUrl} alt="Shared in chat" loading="lazy" />}
          {message.text && <p>{message.text}</p>}
          <time>{formatTime(message.createdAt)}</time>
        </Card>
      </article>;
    }) : <EmptyState title="No messages yet" />}
    <div ref={endRef} />
  </div>;
}
